import {saveState, loadState} from "@/helpers/persistanceStorage";


const state = {
    products: loadState() || [
        {
            id: 1,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '10 000 руб.'
        },
        {
            id: 2,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '2 833 руб.'
        },
        {
            id: 3,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '6 542 руб.'
        },
        {
            id: 4,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '1 278 руб.'
        },
        {
            id: 5,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '2 344 руб.'
        },
        {
            id: 6,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '9 120 руб.'
        },
        {
            id: 7,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '10 000 руб.'
        },
        {
            id: 8,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '1 400 руб.'
        },
        {
            id: 9,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '10 000 руб.'
        },
        {
            id: 10,
            username: 'Наименование товара',
            textarea: 'Довольно-таки интересное описание товара в несколько строк. Довольно-таки интересное описание товара в несколько строк',
            number: '10 000 руб.'
        },
    ]
}

export const mutationTypes = {
    ADD_TO_LIST: '[products] ADD_TO_LIST',
    REMOVE_FROM_LIST: '[products] REMOVE_FROM_LIST'
}
const mutations = {
    [mutationTypes.ADD_TO_LIST]: (state, product) => {
        state.products.push(product)
        saveState(state.products);
    },
    [mutationTypes.REMOVE_FROM_LIST]: (state, index) => {
        state.products.splice(index, 1)
        saveState(state.products);
    },
}

const getters = {
    PRODUCTS(state) {
        return state.products
    },
}


export default {
    state,
    mutations,
    getters
}